import store from '@/store'
import { print } from '@/mla-shared'

// Global mixin for all editable input fields
// Will trigger an error message if rules are not satisfied
export const inputs = {
  methods: {
    change: function (this:any, event:number, field:string) {
      // If empty field or negative value, and field error does not exist
      if ((!event || event < 0)) {
        if (store.state.errors.indexOf(field) < 0) {
          store.state.errors.push(field)
        }
        store.state.errorAlert = true
      } else {
        store.state.errors.splice(store.state.errors.indexOf[field], 1)
      }
      if (store.state.errors.length < 1) {
        store.state.errorAlert = false
      }
    }
  }
}

// Used for conditional rendering on touchscreen and non-touchscreen devices
declare global {
  interface Window {
    PointerEvent:any
    TouchEvent:any
  }
}
export const touchScreen = {
  methods: {
    detect () {
      let result = false
      if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
        // if Pointer Events are supported, just check maxTouchPoints
        if (navigator.maxTouchPoints > 0) {
          result = true
        }
      } else {
        // no Pointer Events...
        if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
          // check for any-pointer:coarse which mostly means touchscreen
          result = true
        } else if (window.TouchEvent || ('ontouchstart' in window)) {
          // last resort - check for exposed touch events API / event handler
          result = true
        }
      }
      // console.log('Is a touchscreen', result)
      return result
    }
  }
}

// Print page
export const printPage = {
  methods: {
    printPage() {
      print()
    }
  }
}

// Print the selected table
export const printTable = {
  methods: {
    printTable: function(this: any, tableId: string) {
      // Get table
      let divToPrint: any = document.getElementById(tableId);

      // Add styles
      divToPrint.style.textAlign = "center";
      divToPrint.style.fontFamily = '"Roboto", sans-serif';
      let th: any = document.getElementsByTagName("th");
      th.forEach((element: any) => {
        element.style.fontSize = "12px";
      });
      let td: any = document.getElementsByTagName("td");
      td.forEach((element: any) => {
        element.style.outline = "thin solid #e7e7e7";
      });
      // Hide buttons and icons
      let buttons: any = document.getElementsByTagName("button");
      buttons.forEach((element: any) => {
        element.style.display = "none";
      });
      let icons: any = document.getElementsByClassName("v-icon");
      icons.forEach((element: any) => {
        element.style.display = "none";
      });

      // Open Print window
      let newWin: any = window.open();
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();

      // Remove styles
      divToPrint.style.textAlign = "inherit";
      divToPrint.style.fontFamily = "inherit";
      td.forEach((element: any) => {
        element.style.outline = "inherit";
      });
      buttons.forEach((element: any) => {
        element.style.display = "inline-flex";
      });
      icons.forEach((element: any) => {
        element.style.display = "inline";
      });

      // Close
      newWin.close();
    }
  }
}

// Update service workers
export const update = {
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  created(this:any) {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  },
  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(this:any, event:any) {
      this.registration = event.detail
      this.updateExists = true
      // Call immediately no user confirmation
      // this.refreshApp()
    },
    // Called when the user accepts the update
    refreshApp(this:any) {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}

